<section>

  <div class="instruction-text">
    Map Items to Onelynk Items
  </div>

  <form>
    <div *ngIf="defaultConfiguration">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Catalog*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <div class="p-inputgroup">
            <button pButton type="button" icon="fa fa-th-list" style="color:#000080!important;"
                    (click)="displayCatalogSelectionDialog = true"></button>
            {{defaultConfiguration?.catalogName}}
          </div>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>U/M *</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="unitOfMeasure" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [style]="{'width':'250px'}"
                      [options]="unitsDropdown" [filter]="true"
                      [(ngModel)]="defaultConfiguration.unitOfMeasureId" required></p-dropdown>
        </div>
      </div>
    </div>

  <div class="p-grid">
<!--    <app-data-table [columns]="tableColumns" [value]="defaultConfiguration?.accountMappings" [leftCaptionTemplate]="leftCaption" sortField="itemType">-->
<!--      <ng-template #leftCaption>-->
<!--        <button pButton class="button-inaction" icon="fa fa-refresh" type="button" label="Refresh Configuration" (click)="refreshDefaultConfiguration()">-->
<!--        </button>-->
<!--      </ng-template>-->
<!--      <ng-template #ledgerAccountTemplate let-row="row" let-rowIndex="rowIndex" >-->
<!--        <p-dropdown  name="ledgerAccount-{{rowIndex}}" [placeholder]="Validation.DropdownPlaceholder"-->
<!--                    [options]="this.dropDownMap?.get(row?.accountMappingType)"-->
<!--                    [style]="{'overflow':'visible', 'max-width':'none'}"-->
<!--                    [showClear]="true" [filter]="true"-->
<!--                    [(ngModel)]="row.ledgerAccountId"></p-dropdown>-->

<!--      </ng-template>-->

<!--    </app-data-table>-->
  </div>

  <div class="p-grid">
    <div class="p-col-12 p-md-12 p-lg-12" style="text-align:right;margin-top:10px;">
      <button pButton type="button" class="button-action" icon="fa fa-check" label="Save"
              (click)="saveDefaultConfiguration()">
      </button>

    </div>
  </div>

  </form>

  <p-dialog [(visible)]="displayCatalogSelectionDialog" [modal]="true" [responsive]="true">
    <p-tree [value]="itemCatalogTreeNodes" styleClass="catalog-selection-overlay" selectionMode="single"
            (onNodeSelect)="onSelectCatalogNode($event.node)">
    </p-tree>
  </p-dialog>

</section>

